import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import SurveyTransferMappingService from '../../../Services/SurveyTransferMappingService';
import SurveyTransferMappingItem from '../../../Domain/SurveyTransferMappingItem';
import AssignmentStatusEnum, { getAssignmentStatusName } from '../../../Enums/AssignmentStatusEnum';

// Only these statuses may be chosen as a mapping's target status.
const ALLOWED_TARGET_STATUSES = [
  AssignmentStatusEnum.Reviewed,
  AssignmentStatusEnum.Finalized,
  AssignmentStatusEnum.Emailed,
  AssignmentStatusEnum.ClientFinalized,
  AssignmentStatusEnum.Locked,
];

// Target status options: the allowed statuses by name, plus a leading "(None)" placeholder
// so an unset value isn't shown as the first real status (and can be cleared).
const TARGET_STATUS_OPTIONS = ALLOWED_TARGET_STATUSES.map((value) => ({
  value,
  label: getAssignmentStatusName(value),
}));

// GeneralEditPanelBase (Figma) description for editing a single survey transfer mapping.
// Editable: the TargetStatus (shown/selected by its AssignmentStatusEnum name) and whether Apollo
// should send its trigger emails for the transferred shops (CD-5392).
export default class SurveyTransferMappingEditPanelDescription {
  static itemType = SurveyTransferMappingItem;
  static headerForEditPanel = 'Edit Survey Transfer Mapping';
  static headerForCreatePanel = 'Edit Survey Transfer Mapping';
  static labelForSubmitButton = 'Save';
  static nameOfTheIdField = 'SurveyTransferMappingId';
  static icon = 'fa-solid fa-edit';
  static messageOnSuccess = 'The mapping has been saved.';

  static clickOnSubmitFunction = (editedItem) =>
    SurveyTransferMappingService.UpdateSurveyTransferMappingTargetStatus(editedItem);

  static fieldsInEditPanel = [
    {
      fieldName: 'TargetStatus',
      label: 'Target Status',
      className: 'col-12',
      type: InputTypesEnum.Select,
      options: TARGET_STATUS_OPTIONS,
      // Required: "(None)" (value '') and any non-positive value fail validation.
      validityChecker: ValidityHelper.forRequiredSelectField,
    },
    {
      // Apollo does not fire a survey's triggers for imported shops, so the export asks for them in
      // a separate call. Off means no trigger email is requested for this survey's transfers.
      fieldName: 'SendTriggers',
      label: 'Send Trigger Emails',
      className: 'col-12',
      type: InputTypesEnum.OnOff,
      validityChecker: ValidityHelper.AlwaysFlawless,
    },
  ];
}
